import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import Process from "../components/Process";
import Stats from "../components/Stats";
import Portfolio from "../components/Portfolio";
import AIShowcase from "../components/AIShowcase";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import DarkCta from "../components/DarkCta";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      {/* <Stats /> */}
      <Services />
      {/* <WhyChooseUs /> */}
      <AIShowcase />
      <Process />
      <Portfolio />
      <Testimonials />
      <Contact />
      <DarkCta />
      <Footer />
      <WhatsAppButton />
    </>
  );
}

export default Home;
